var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      rotate: "45deg"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4772_11683)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.496 3.50533C12.5503 3.5595 12.5934 3.62386 12.6228 3.69472C12.6522 3.76557 12.6673 3.84154 12.6673 3.91825C12.6673 3.99496 12.6522 4.07092 12.6228 4.14178C12.5934 4.21263 12.5503 4.27699 12.496 4.33117L4.33086 12.4963C4.22135 12.6058 4.07282 12.6673 3.91794 12.6673C3.76307 12.6673 3.61454 12.6058 3.50502 12.4963C3.39551 12.3868 3.33398 12.2382 3.33398 12.0834C3.33398 11.9285 3.39551 11.78 3.50502 11.6704L11.6701 3.50533C11.7243 3.45101 11.7887 3.40792 11.8595 3.37852C11.9304 3.34912 12.0063 3.33398 12.0831 3.33398C12.1598 3.33398 12.2357 3.34912 12.3066 3.37852C12.3774 3.40792 12.4418 3.45101 12.496 3.50533V3.50533Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50484 3.50533C3.45053 3.5595 3.40743 3.62386 3.37803 3.69472C3.34863 3.76557 3.3335 3.84154 3.3335 3.91825C3.3335 3.99496 3.34863 4.07092 3.37803 4.14178C3.40743 4.21263 3.45053 4.27699 3.50484 4.33117L11.6699 12.4963C11.7795 12.6058 11.928 12.6673 12.0829 12.6673C12.2377 12.6673 12.3863 12.6058 12.4958 12.4963C12.6053 12.3868 12.6668 12.2382 12.6668 12.0834C12.6668 11.9285 12.6053 11.78 12.4958 11.6704L4.33068 3.50533C4.27651 3.45101 4.21215 3.40792 4.14129 3.37852C4.07044 3.34912 3.99447 3.33398 3.91776 3.33398C3.84105 3.33398 3.76509 3.34912 3.69423 3.37852C3.62337 3.40792 3.55902 3.45101 3.50484 3.50533V3.50533Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4772_11683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(3.33325 3.33301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9183844bf18b25e611387d2a0f5d168f.svg";
export { ForwardRef as ReactComponent };